import * as React from 'react';
import './PostFooter.styles.scss';

export const year = new Date().getFullYear();

/**
 * Basic footer component for content inside the <main> tag
 */
export const PostFooter = () => {
  return (
    <div id="post-footer">
      Copyright {year} ©{' '}
      <a
        href="https://phenixrts.com/en-us/"
        target="_blank"
        rel="noopener noreferrer">
        Phenix RTS
      </a>
      <br />
      <div className="tos">
        <a
          href="https://phenixrts.com/en-us/privacy-policy.html"
          target="_blank"
          rel="noopener noreferrer">
          Privacy Policy
        </a>{' '}
        |{' '}
        <a
          href="https://phenixrts.com/en-us/terms-of-service.html"
          target="_blank"
          rel="noopener noreferrer">
          Terms of Service
        </a>
      </div>
    </div>
  );
};
